export default __webpack_public_path__ + "static/media/1045.db2f144d.svg";